import { css } from 'emotion'
import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import IMG1 from './../../../static/rm-charity-org.jpg'
import { Colors, Font } from './../../../styles'
import { Card } from './../../../components'
import { fetchCharity } from './../../../services/ApiController'

const Style = css({
  '.charity': {
    '&-inner': {
      padding: '2rem 1.25rem',
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'center',
      '@media (max-width: 1023px)': {
        '.card': {
          maxWidth: '50%',
          flexBasis: '50%',
          minWidth: '1px',
          padding: '.5rem',
        },
      },
      '.card-info': {
        minHeight: 140,
      },
      '@media (min-width: 1024px)': {
        padding: '4rem',
      }
    }
  },
})

export default class CharityCatalog extends Component {
  state = {
    data: []
  }

  componentDidMount() {
    fetchCharity().then((res) => {
      this.setState({ data: res.pages })
    })
  }

  render() {
    console.log(this.state.data)
    return (
      <div className={`charity ${Style}`}>
        <div className="charity-inner">
          { this.state.data.length > 0 && (
           this.state.data.map((item) => (
              <Card 
                title={item.title}
                cover={item.cover}
                card_picture={item.card_picture}
                slug={item.slug}
                is_bookmark={item.is_bookmark}
                slug_bookmark={item.slug_bookmark}
                type={item.type}
                key={item.id} 
                shadow
                category={null} 
                label="discover" />
            ))
          )
          }
          <Card
            title="CLIENT REGISTER FORM"
            cover={IMG1}
            card_picture={IMG1}
            slug="/brand/charity/contact"
            is_bookmark={null}
            slug_bookmark={null}
            type=""
            shadow
            category={null}
            label="Register" />
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/scenes/Pages/container/CharityCatalog.js